import React from 'react';
import Icon from '@ant-design/icons';
import NoDataSvg from './noData.svg';
import { IconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const NoDataIcon = (props: IconComponentProps) => <Icon component={NoDataSvg} {...props} />;
